<template>
  <div class="container">
	<form class="row mx-1" id="filter">
		<fieldset v-for="(category, k) in categories" :key="k" class="form-group text-left col-4 col-md-2 d-flex align-items-center">
			<legend data-toggle="collapse" :data-target="'#'+k" role="button" aria-expanded="false" :aria-controls="k" class="d-flex align-items-middle">
				<div class="my-auto w-100 text-center">{{category.name}}</div> <!-- <img src="/img/expand-arrow.png" class="bird"> -->
			</legend>
			<div :id="k" class="collapse dropdown">
				<div class="form-check" v-for="(d, i) in category.values" :key="k+i">
					<input v-model="filters[k]" type="checkbox" :value="d" @change="filter()" :id="k+i" class="form-check-input">
					<label class="form-check-label ml-1" :for="'equipment'+i">
						{{d}}
					</label>
				</div>
			</div>
		</fieldset>
	</form>
	<div class="row mt-4">
		<article v-for="(game, idx) in games" :key="idx" class="col-6 col-lg-4 mb-4">
			<router-link :to="'/GameDetail/'+idx">
			<div class="d-flex align-items-middle" @click="pushProps(game)">
				<h3 class="my-auto px-2 w-100 text-center">{{ game.name }}</h3>
			</div>
			</router-link>
		</article>
	</div>
  </div>
</template>

<script>
import { db } from '../main'

export default {
	name: 'GamesLib',
	data () {
		return {
			games: [],
			filters: {
				equipment: [],
				development: [],
				activity: [],
				age: [],
				season: [],
				topics: []
			},
			categories: {
				age: {
					name: 'Возраст',
					values: ['1-3 года', '3-5 лет', '5-7 лет']
				},
				development: {
					name: 'Область развития',
					values: ['физическое', 'познавательное', 'речевое', 'социально-коммуникативное', 'художественно-эстетическое', 'работа в команде']
				},
				topics: {
					name: 'Тематика',
					values: ['народные', 'дворовые', 'про животных', 'про насекомых', 'про профессии', 'про явления природы', 'про транспорт', 'сказочные персонажи', 'соревнования']
				},
				activity: {
					name: 'Физическая активность',
					values: ['малоподвижные', 'подвижные']
				},
				season: {
					name: 'Сезон',
					values: ['зима', 'весна', 'лето', 'осень', 'все сезоны']
				},
				equipment: {
					name: 'Оборудование',
					values: ['Да', 'Нет']
				},
			}
		}
	},
	methods: {
		filter: function() {
			db.collection('games').orderBy('name').get().then(querySnapshot => {
				this.games = querySnapshot.docs.map(doc => doc.data());
				for (var flt in this.filters) {
					if (this.filters[flt].length > 0) {
						var filtered = [];
						for (var game in this.games) {
							if (this.games[game][flt]) {
								let intersection = this.games[game][flt].filter(x => this.filters[flt].includes(x));
								if (intersection.length > 0) filtered.push(this.games[game]);
							}
						}
						if (filtered.length > 0) this.games = filtered;
					}
				}
			})
		},
		pushProps: function(prop) {
			this.$router.push({
				name: 'gameDetail',
				params: {
					game: prop
				}
			})
		}
	},
	created () {
		db.collection('games').orderBy('name').get().then(querySnapshot => {
			this.games = querySnapshot.docs.map(doc => doc.data())
		})
	// Object.assign(this.filters, this.categories)
	}
}
</script>

<style>
	article {
		text-align: center;
	}
	fieldset {
		position: relative;
	}
	legend {
		font-weight: bold;
		font-size: 1rem;
		line-height: 1rem;
		margin-bottom: 0px;
		padding-top: 0.8rem;
		height: 4rem;
		overflow: hidden;
	}
	@media (min-width: 1200px) {
		legend {
			font-size: 1.3rem;
			line-height: 1.3rem;
		}
	}
	.dropdown {
		position: absolute;
		top: 1rem;
		background-color: white;
		padding: 0.5rem;
		width: 90%;
		z-index: 100;
	}
	a {
		color: inherit;
	}
	a:hover {
		color: inherit;
		text-decoration: none;
	}
	#filter {
		background-color: #ff9898ff;
		border-radius: 10px;
		margin-top: -1.5rem;
	}
	a div {
		min-height: 6.5rem !important;
		border-radius: 10px;
		background-color: #fbe793ff;
	}
	h3 {
		font-size: 1.5rem;
	}
</style>
